<template>
  <div id="app">
    <l-head id="header"></l-head>
    <div class="whatApp" @click="openWhatsApp">
      <img src="@/assets/img/whatAppLogo1.png" alt=""></img>
    </div>
    <div class="aiKF" @click="isColse = true">
      <img src="@/assets/img/liaison/words.png" alt=""></img>
    </div>

    <l-dialog v-if="isColse" @colse="colse" title="AI在线客服">
      <iframe src="https://customer.az.chat/app/kw/#/chat?bh=0AvE0YVP9u9oj5cbi1718949531&source=SEA HORSE"
        width="750px"
        height="594px"
        frameborder="0">
      </iframe>
    </l-dialog>
    <router-view :key="key" />
  </div>
</template>

<script>
import dialog from "@/components/dialog";
import head from "./components/head.vue";
export default {
  name: "App",
  created() {
    this.$zhTran("t");
    window.addEventListener("scroll", this.handleScroll);
    // this.$http.post("/api/user/refresh-token").then(res => {
    //   console.log(res)
    // })
    // setInterval(() => {
    //   console.log(1)
    // },3000)


    // 判断是否为移动设备访问
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
      // 测试
      // let Domain = 'http://h5.haima.lhzh88.cn/#/'
      // 生产
      // let Domain = 'http://wap.seahorse.com.hk/#/'
      let Domain = 'http://wap.mattress.com.hk/#/'
      if (window.location.href.indexOf('/contact') !== -1 ) {
        // 测试
        window.location.href = `${Domain}pages/store/store`
      } else if (window.location.href.indexOf('/allList')  !== -1) {
        // 测试
        window.location.href = `${Domain}pages/store/store${window.location.search}`
      } else if(window.location.href.indexOf('/goods/detail') !== -1) {
        const url = window.location.href
        const parts = url.split('/');
        const id = parts[parts.length - 1];
        // 测试
        window.location.href = `${Domain}shopPages/pages/shop/detail?id=${id}`
      } else if(window.location.href.indexOf('/join') !== -1) {
        const url = window.location.href
        const parsedUrl = new URL(url);
        const params = new URLSearchParams(parsedUrl.search);
        const themeid = params.get('themeid');
        // 测试
        window.location.href = `${Domain}shopPages/pages/shop/list?themeId=${themeid}`
      } else {
        // 测试
        window.location.href = `${Domain}`
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll, true);
  },
  components: {
    "l-head": head,
    lDialog: dialog,
  },
  data() {
    return {
      isHead: true,
      roll: 0,
      isColse: false,
    };
  },
  methods: {
    openWhatsApp() {
      window.open('https://api.whatsapp.com/send?phone=+94284465&text=Hello',"_blank")
    },
    colse() {
      this.isColse = !this.isColse;
    },
    handleScroll() {
      // 页面滚动距顶部距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let scroll = scrollTop - this.roll;
      this.roll = scrollTop;

      // 在顶部时，需要去掉fixed
      if (scrollTop === 0) {
        document.getElementById("header").classList.remove("fixed");
        // document.getElementById("header").classList.remove("el-fade-in-linear");
        // document.getElementById("header").classList.remove("show");
        return;
      }

      // 鼠标向上滚动
      if (scroll < 0) {
        document.getElementById("header").classList.add("fixed");
        document.getElementById("header").classList.add("el-fade-in-linear");
        // document.getElementById("header").classList.add("show");
      } else {
        // 鼠标向下滚动
        document.getElementById("header").classList.remove("fixed");
        // document.getElementById("header").classList.remove("el-fade-in-linear");
        // document.getElementById("header").classList.remove("show");
      }
    },
  },
  computed: {
    key() {
      return this.$route.name
        ? this.$route.name + +new Date()
        : this.$route + +new Date();
    },
  },
};
</script>

<style>
html,body{
  font-family: '\5B8B\4F53', 'SimSun',  'Arial', 'Helvetica', 'sans-serif'  !important;
}
.whatApp{
  width: 69.5px;
  height: 68.5px;
  position: fixed;
  bottom: 40px;
  left: 40px;
  cursor: pointer;
  z-index: 999;
}
.cursor-pointer{
  cursor: pointer;
}
.whatApp img{
  width: 100%;
  height: 100%;
}
.aiKF{
  width: 69.5px;
  height: 68.5px;
  position: fixed;
  bottom: 40px;
  right: 40px;
  cursor: pointer;
  z-index: 999;
}
.aiKF img{
  width: 100%;
  height: 100%;
}
.fixed {
  position: fixed;
  width: 100%;
  z-index: 10000;
  background: #fff;
  animation: anim 1s linear;
}
@keyframes anim {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@import "./assets/style/css/main.css";
</style>



// WEBPACK FOOTER //
// src/App.vue